import { Axios, AxiosResponse } from "axios";
import {Store} from "../../configureStore";
import { put, call, takeLatest,select } from "redux-saga/effects";
import { storeCartRestaurantDetails } from "../cart/cartActions";
import {
  successRestaurantDetails,
  failedRestaurantDetails,
  successRestaurantMenuDetails,
  failedRestaurantMenuDetails,
  successFeedbackDetails,
  failedFeedbackDetails,
  successSubmitFeedbackDetails,
  failedSubmitFeedbackDetails,
  successRestaurants,
  failedRestaurants,
  successGetServingLocations,
  failedGetServingLocations,
  getRestaurantDetailsByLocationIdSuccess,
  getActiveOrderRestaurant,
  getActiveOrderRestaurantSuccess,
  getMasterHomePageDetailsFailed,
  getMasterHomePageDetailsSuccess,
  getRestaurantTableDetailsSuccess,
  getRestaurantTableDetailsFailed,
  addDeliveryAddressRequest,
  addDeliveryAddressSuccess,
  addDeliveryAddressFailure,
  viewDeliveryAddressSuccess,
  viewDeliveryAddressFailure,
  editDeliveryAddressSuccess,
  editDeliveryAddressFailure,
  deleteDeliveryAddressSuccess,
  deleteDeliveryAddressFailure,
  viewDeliveryAddressRequest,
  AddFavSuccess,
  AddFavFailure,
  RemoveFavSuccess,
  RemoveFavFailure,
  GetFavSuccess,
  GetFavFailure,
  GetFavRequest,
  exploreMenuSuccess,
  exploreMenuFailure,
  getCouponSuccess,
  getCouponFailure,
  validateCouponSuccess,
  validateCouponFailure,
  redeemCouponSuccess,
  redeemCouponFailure,
  appliedCoupon,
  validateCouponFailureMessage,
} from "./restaurantAction";
import {
  addDeliveryAddress,
  AddFav,
  deleteDeliveryAddress,
  editDeliveryAddress,
  exploreMenu,
  getCoupon,
  getFav,
  getFeedbackDetails,
  getmasterRestaurantHomePageDetails,
  getRestaurantDetails,
  getRestaurantDetailsbyLocationId,
  getRestaurantMenuDetails,
  getRestaurantMenuDetailsByEventDate,
  getRestaurants,
  getRestaurantTableDetails,
  redeemCoupon,
  removeFav,
  submitFeedback,
  validateCoupon,
  viewDeliveryAddress,
} from "./restaurantAPI";
import { getCookie } from "../../../helper/cookieHelper";
import { USER_ID } from "../../constants";
import {
  ACTIVE_ORDER_RESTAURANT_REQUEST,
  ADD_DELIVERY_ADDRESS_REQUEST,
  ADD_FAV_REQUEST,
  DELETE_DELIVERY_ADDRESS_REQUEST,
  EDIT_DELIVERY_ADDRESS_REQUEST,
  FEEDBACK_DETAIL_REQUEST,
  GET_COUPONS_REQUEST,
  GET_EXPLORE_MENU_REQUEST,
  GET_FAV_REQUEST,
  GET_MASTER_HOME_PAGE_DETAILS,
  GET_RESTAURANT_TABLE_DETAILS,
  REDEEM_COUPONS_REQUEST,
  REMOVE_FAV_REQUEST,
  RESTAURANTS_REQUEST,
  RESTAURANT_DETAIL_LOCATION_ID_REQUEST,
  RESTAURANT_DETAIL_REQUEST,
  RESTAURANT_MENU_DETAIL_REQUEST,
  RESTAURANT_MENU_DETAIL_REQUEST_BY_DATE,
  SERVING_RESTAURANTS_REQUEST,
  SUBMIT_FEEDBACK_DETAIL_REQUEST,
  UPDATE_CURRENT_ACTIVE_MENU,
  VALIDATE_COUPONS_REQUEST,
  VIEW_DELIVERY_ADDRESS_REQUEST,
} from "./restaurantContants";
import {
  FeedbackQuestion,
  RestaurantMenuRequest,
  RestaurantMenuResponse,
  RestaurantsRequestParams,
  SubmitFeedbackDetail,
  RestaurantItemDetail,
  RestaurantDetailRequest,
  RestaurantDetailByLocationIdRequest,
} from "./restaurantModels";
import { getAvailableCatgorySubCategory } from "../../utils/menu-helper-utils";
import { getEventDate, getEventSlug } from "../selectors";
import { decryptJson } from "../../utils/react-ec-utils";
import { showErrorToast, showErrorToastDesktop } from "../../utils/toastUtils";

function* getLocationRestaurantsSaga(action: any) {
  try {
    const requestDetails = action.payload as RestaurantsRequestParams;

    const response: AxiosResponse = yield call(getRestaurants, requestDetails);
    if (response.status === 200) {
      const data = decryptJson(response.data.encryptedText)
      yield put(successRestaurants(data as RestaurantItemDetail[]));
    } else if (response.status === 400) {
      yield put(failedRestaurants({ message: "Please Try Again" }));
    }
  } catch (err) {
    yield put(failedRestaurants({ message: "Please Try Again" }));
  }
}

function* getServingRestaurantsSaga(action: any) {
  try {
    const requestDetails = action.payload as RestaurantsRequestParams;

    const response: AxiosResponse = yield call(getRestaurants, requestDetails);
    if (response.status === 200) {
      const data = decryptJson(response.data.encryptedText)
      yield put(
        successGetServingLocations(data as RestaurantItemDetail[])
      );
    } else if (response.status === 400) {
      yield put(failedGetServingLocations({ message: "Please Try Again" }));
    }
  } catch (err) {
    yield put(failedGetServingLocations({ message: "Please Try Again" }));
  }
}

function* getRestaurantDetailsSaga(action: any) {
  let payload = action.payload as RestaurantDetailRequest;

  const eventSlug: string | null = yield select(getEventSlug); 
  const eventDate: boolean = yield select(getEventDate);     
  const isEventOrder = Boolean(eventDate) || Boolean(eventSlug);
  
  try {
    const response: AxiosResponse = yield call(
      getRestaurantDetails,
      payload.slug as string
    );

    if (response.status === 200) {   
      const decryptedData = decryptJson(response.data.encryptedText)   
      yield put(successRestaurantDetails({ detail: decryptedData,isEventOrder}));  
      localStorage.removeItem('theme')

      if ( payload?.sagaCallBack != null &&typeof payload?.sagaCallBack === 'function') {
        payload.sagaCallBack(true, decryptedData?.deliveryCutOffTimeExceeds, decryptedData?.pickupCutOffTimeExceeds, decryptedData);
      }
    } else{
      yield put(failedRestaurantDetails({ message: "Please Try Again",isEventOrder }));
      if ( payload?.sagaCallBack != null &&typeof payload?.sagaCallBack === 'function') {
        payload.sagaCallBack(false,1,1,'');
      }
    }
  } catch (err) {
    yield put(failedRestaurantDetails({ message: "Please Try Again",isEventOrder }));
    if ( payload?.sagaCallBack != null &&typeof payload?.sagaCallBack === 'function') {
      payload.sagaCallBack(false,1,1,'');
    }
  }
}

function* getRestaurantDetailsByLocationIdSaga(action: any) {
  const eventSlug: string | null = yield select(getEventSlug); 
  const eventDate: boolean = yield select(getEventDate);     

  const isEventOrder = Boolean(eventDate) || Boolean(eventSlug);
  try {
    let payload = action.payload as RestaurantDetailByLocationIdRequest;
    const response: AxiosResponse = yield call(
      getRestaurantDetailsbyLocationId,
      payload.locationId
    );
    if (response.status === 200) {
      const decryptedData = decryptJson(response.data.encryptedText)
      yield put(getRestaurantDetailsByLocationIdSuccess({ details: decryptedData,isEventOrder}));
    } else if (response.status === 400) {
      yield put(failedRestaurantDetails({ message: "Please Try Again",isEventOrder }));
    }
  } catch (err) {
    yield put(failedRestaurantDetails({ message: "Please Try Again",isEventOrder }));
  }
}

function* getActiveOrderRestaurantSaga(action: any) {
  try {
    let payload = action.payload as RestaurantDetailByLocationIdRequest;
    const response: AxiosResponse = yield call(
      getRestaurantDetailsbyLocationId,
      payload.locationId
    );
    if (response.status === 200) {
      const decryptedData = decryptJson(response.data.encryptedText)
      yield put(getActiveOrderRestaurantSuccess(decryptedData));
    } else if (response.status === 400) {
      yield put(failedRestaurantDetails({ message: "Please Try Again" }));
    }
  } catch (err) {
    yield put(failedRestaurantDetails({ message: "Please Try Again" }));
  }
}

function* getRestaurantMenuDetailsByDateSaga(action: any) {
  try {
    const response: AxiosResponse = yield call(getRestaurantMenuDetailsByEventDate,action.payload as RestaurantMenuRequest);
    if (response.status === 200) {
      const decryptdata=decryptJson(response.data.encryptedText)
      const responseData = decryptdata as RestaurantMenuResponse;
      const { categoryTypes, subCategoryTypes } = getAvailableCatgorySubCategory(responseData.menu);

      yield put(
        storeCartRestaurantDetails(
          (Store.getState() as any).restaurant.currentRestaurantDetail,
          responseData.orderTax || [],
          responseData.defaultItemTax
        )
      );
      const rData = {...responseData, categoryTypes, subCategoryTypes,eventSlot:responseData?.eventOrderSlot }
      yield put(successRestaurantMenuDetails(rData));
    } else {
      yield put(failedRestaurantMenuDetails({ message: "Please Try Again" }));
    }
  } catch (err) {
    yield put(failedRestaurantMenuDetails({ message: "Please Try Again" }));
  }
}

function* getRestaurantMenuDetailsSaga(action: any) {

  try {
    const response: AxiosResponse = yield call(
      getRestaurantMenuDetails,
      action.payload as RestaurantMenuRequest
    );
    if (response.status === 200) {
      yield put({ type: UPDATE_CURRENT_ACTIVE_MENU, payload: action.payload.type })

      const responseData = decryptJson(response.data.encryptedText) as RestaurantMenuResponse;
      const { categoryTypes, subCategoryTypes } = getAvailableCatgorySubCategory(responseData.menu);

      yield put(
        storeCartRestaurantDetails(
          (Store.getState() as any).restaurant.currentRestaurantDetail,
          responseData.orderTax || [],
          responseData.defaultItemTax
        )
      );
      const rData = {...responseData, categoryTypes, subCategoryTypes }
      yield put(successRestaurantMenuDetails(rData));
      action.payload?.sagaSuccessCB && typeof action.payload?.sagaSuccessCB === 'function' && action.payload?.sagaSuccessCB(rData?.menu)
    } else{
      yield put(failedRestaurantMenuDetails({ message: "Please Try Again" }));
    }
  } catch (err) {
    yield put(failedRestaurantMenuDetails({ message: "Please Try Again" }));
  }
}


//Explore Menu
function* getExploreMenuSaga(action: any) {
  try{
    const response: AxiosResponse = yield call(exploreMenu, action.payload)

    if(response.status === 200){
      yield put(exploreMenuSuccess(response.data))
    }else{
      yield put(exploreMenuFailure(response.data))
    }
  }catch(err: any){
    yield put(exploreMenuFailure(err))
  }
}

function* getMasterHomePageDetailsSaga(action: any) {
  try {
    const response: AxiosResponse = yield call(
      getmasterRestaurantHomePageDetails,
      action.payload as string
    );
    if (response.status === 200) {
      yield put(getMasterHomePageDetailsSuccess(response.data));
    } else if (response.status === 400) {
      // yield put(getMasterHomePageDetailsFailed({ message: "Please Try Again" }));
      console.info("Failed to get master homepage Details::");
    }
  } catch (err) {
    console.error("Failed to get master homepage Details::", err);
  }
}

function* getFeedbackDetailsSaga(action: any) {
  try {
    const response: AxiosResponse = yield call(getFeedbackDetails);
    const decryptdata=decryptJson(response?.data?.encryptedText)
    if (response.status === 200) {
      yield put(
        successFeedbackDetails(decryptdata.question as FeedbackQuestion[])
      );
    } else {
      yield put(failedFeedbackDetails());
    }
  } catch (err) {
    yield put(failedFeedbackDetails());
  }
}

function* SubmitFeedbackDetailsSaga(action: any) {
  try {
    const response: AxiosResponse = yield call(
      submitFeedback,
      action.payload as SubmitFeedbackDetail
    );
    if (response.status === 200) {
      yield put(successSubmitFeedbackDetails());
    } else {
      yield put(failedSubmitFeedbackDetails());
    }
  } catch (err) {
    yield put(failedSubmitFeedbackDetails());
  }
}

function* getRestaurantTableDetailsSaga(action: any) {
  let payload = action.payload as string;

  try {
    const response: AxiosResponse = yield call(
      getRestaurantTableDetails,
      payload as string
    );
    if (response.status === 200) {
      const data = decryptJson(response.data.encryptedText)
      yield put(getRestaurantTableDetailsSuccess(data));
    } else if (response.status === 400) {
      yield put(getRestaurantTableDetailsFailed());
    }
  } catch (err) {
    yield put(getRestaurantTableDetailsFailed());
  }
}

function* addDeliveryAddressSaga(action: any) {
  let payload = action.payload
 const isMobile = window.innerWidth <= 768;
  try{
    const response: AxiosResponse = yield call(addDeliveryAddress, payload)
    if(response.status === 200){
      yield put(addDeliveryAddressSuccess(response.data))
      yield put(viewDeliveryAddressRequest())
    }else{
      
       if(isMobile){
        showErrorToast(response?.data?.message)
      }else{
        showErrorToastDesktop(response?.data?.message)
      }
      
   
      yield put(addDeliveryAddressFailure(response.data))
    }
  }catch(err: any){

      if(isMobile){
        showErrorToast('Something went wrong !')
      }else{
        showErrorToastDesktop('Something went wrong !')
      }
    
    yield put(addDeliveryAddressFailure(err))
  }
}

function* viewDeliveryAddressSaga(action: any) {
  try{
    // Check if customerID exists before making the API call
    const customerID = getCookie(USER_ID);
    
    if (!customerID) {
      // Don't make API call if no customerID (prevents 401 after refresh/403)
      // Silently return without dispatching failure to avoid triggering 401 handler
      return;
    }
    
    const response: AxiosResponse = yield call(viewDeliveryAddress)
    if(response.status === 200){
      yield put(viewDeliveryAddressSuccess(response.data))
    }else{
      yield put(viewDeliveryAddressFailure(response.data))
    }
  }catch(err: any){
    // Only dispatch failure if it's not a 401 from missing customerID
    // This prevents the 401 interceptor from triggering when customerID is missing
    if (err?.response?.status !== 401 || err?.response?.data?.message !== 'Customer ID not found') {
      yield put(viewDeliveryAddressFailure(err))
    }
    // Silently handle missing customerID case
  }
}


function* editDeliveryAddressSaga(action: any) {
  let payload = action.payload

  try{
    const response: AxiosResponse = yield call(editDeliveryAddress, payload)
    if(response.status === 200){
      yield put(editDeliveryAddressSuccess(response.data))
      yield put(viewDeliveryAddressRequest())
    }else{
      yield put(editDeliveryAddressFailure(response.data))
    }
  }catch(err: any){
    yield put(editDeliveryAddressFailure(err))
  }
}

function* deleteDeliveryAddressSaga(action: any) {
  let payload = action.payload

  try{
    const response: AxiosResponse = yield call(deleteDeliveryAddress, payload)
    if(response.status === 200){
      yield put(deleteDeliveryAddressSuccess(response.data))
    }else{
      yield put(deleteDeliveryAddressFailure(response.data))
    }
  }catch(err: any){
    yield put(deleteDeliveryAddressFailure(err))
  }
}

function* addFavSaga(action: any) {
  let payload = action.payload

  try{
    const response: AxiosResponse = yield call(AddFav, payload)
    if(response.status === 200){
      yield put(AddFavSuccess(response.data))
    yield put(GetFavRequest({locationId:payload?.locationId,customerId:payload?.customerId}))
    }else{
      yield put(AddFavFailure(response.data))
    }
  }catch(err: any){
    yield put(AddFavFailure(err))
  }
}
function* removeFavSaga(action: any) {
  let payload = action.payload

  try{
    const response: AxiosResponse = yield call(removeFav, payload)
    if(response.status === 200){
      yield put(RemoveFavSuccess(response.data))
     yield put(GetFavRequest({locationId:payload?.locationId,customerId:payload?.customerId}))
    }else{
      yield put(RemoveFavFailure(response.data))
    }
  }catch(err: any){
    yield put(RemoveFavFailure(err))
  }
}
function* getFavSaga(action: any) {
  let payload = action.payload

  try{
    const response: AxiosResponse = yield call(getFav, payload)
    if(response.status === 200){
      yield put(GetFavSuccess(response.data))
    }else{
      yield put(GetFavFailure(response.data))
    }
  }catch(err: any){
    yield put(GetFavFailure(err))
  }
}


//coupon saga


function* getCouponSaga(action: any) {
  let payload = action.payload

  try{
    const response: AxiosResponse = yield call(getCoupon, payload)
    if(response.status === 200){
      yield put(getCouponSuccess(response.data))
    }else{
      yield put(getCouponFailure(response.data))
    }
  }catch(err: any){
    yield put(getCouponFailure(err))
  }
}

function* validateCouponSaga(action: any) {
  let payload = action.payload;

  try {
    const response: AxiosResponse = yield call(validateCoupon, payload);
    const decryptedData = decryptJson(response.data.encryptedText);

    if (response.status === 200 && decryptedData?.status === 200) {
      yield put(validateCouponSuccess(decryptedData));
      if(decryptedData?.status === 200){
        yield put(appliedCoupon( {...decryptedData?.couponDetails, offerCode: payload.couponCode, id:decryptedData?.couponDetails.offerId }));
      }
    } else {
      yield put(validateCouponFailure(decryptedData));
      yield put(validateCouponFailureMessage(decryptedData))
    }
  } catch (err: any) {
    yield put(validateCouponFailure(err));
  }
}

function* redeemCouponSaga(action: any) {
  let payload = action.payload

  try{
    const response: AxiosResponse = yield call(redeemCoupon, payload)
    if(response.status === 200){
      yield put(redeemCouponSuccess(response.data))
    }else{
      yield put(redeemCouponFailure(response.data))
    }
  }catch(err: any){
    yield put(redeemCouponFailure(err))
  }
}


export default function* restaurantSaga() {
  yield takeLatest(RESTAURANT_DETAIL_REQUEST, getRestaurantDetailsSaga);
  yield takeLatest(
    RESTAURANT_DETAIL_LOCATION_ID_REQUEST,
    getRestaurantDetailsByLocationIdSaga
  );
  yield takeLatest(RESTAURANT_MENU_DETAIL_REQUEST_BY_DATE,getRestaurantMenuDetailsByDateSaga);
  yield takeLatest(
    RESTAURANT_MENU_DETAIL_REQUEST,
    getRestaurantMenuDetailsSaga
  );
  yield takeLatest(FEEDBACK_DETAIL_REQUEST, getFeedbackDetailsSaga);
  yield takeLatest(SUBMIT_FEEDBACK_DETAIL_REQUEST, SubmitFeedbackDetailsSaga);
  yield takeLatest(RESTAURANTS_REQUEST, getLocationRestaurantsSaga);
  yield takeLatest(SERVING_RESTAURANTS_REQUEST, getServingRestaurantsSaga);
  yield takeLatest(
    ACTIVE_ORDER_RESTAURANT_REQUEST,
    getActiveOrderRestaurantSaga
  );
  yield takeLatest(GET_MASTER_HOME_PAGE_DETAILS, getMasterHomePageDetailsSaga);
  yield takeLatest(GET_RESTAURANT_TABLE_DETAILS, getRestaurantTableDetailsSaga);
  yield takeLatest(ADD_DELIVERY_ADDRESS_REQUEST, addDeliveryAddressSaga);
  yield takeLatest(VIEW_DELIVERY_ADDRESS_REQUEST, viewDeliveryAddressSaga);
  yield takeLatest(EDIT_DELIVERY_ADDRESS_REQUEST, editDeliveryAddressSaga);
  // yield takeLatest(VIEW_DELIVERY_ADDRESS_REQUEST, viewDeliveryAddressSaga);
  yield takeLatest(DELETE_DELIVERY_ADDRESS_REQUEST, deleteDeliveryAddressSaga);
  yield takeLatest(ADD_FAV_REQUEST, addFavSaga);
  yield takeLatest(REMOVE_FAV_REQUEST, removeFavSaga);
  yield takeLatest(GET_FAV_REQUEST, getFavSaga);
  yield takeLatest(GET_EXPLORE_MENU_REQUEST, getExploreMenuSaga)
    yield takeLatest(GET_COUPONS_REQUEST, getCouponSaga);
  yield takeLatest(VALIDATE_COUPONS_REQUEST, validateCouponSaga);
  yield takeLatest(REDEEM_COUPONS_REQUEST, redeemCouponSaga)
}
